import { render, staticRenderFns } from "./AppraisalHeader.vue?vue&type=template&id=701a0f6a&scoped=true"
import script from "./AppraisalHeader.vue?vue&type=script&lang=js"
export * from "./AppraisalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701a0f6a",
  null
  
)

export default component.exports